"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetIdInput = exports.StyledSwitchWrapper = exports.StyledSwitchContainer = exports.StyledSwitch = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _react = _interopRequireDefault(require("react"));
var _Styled = _interopRequireDefault(require("../Typography/Styled"));
var _excluded = ["children", "className", "prefixCls", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledContainer = function StyledContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledSwitch, (0, _extends2.default)({
    prefixCls: prefix,
    $size: size
  }, rest), children(prefix));
};
var rcSwitchOn = {
  small: (0, _ykbStyledComponents.keyframes)(["0%{width:12px;}100%{width:16px;}"]),
  default: (0, _ykbStyledComponents.keyframes)(["0%{width:18px;}100%{width:25px;}"]),
  large: (0, _ykbStyledComponents.keyframes)(["0%{width:26px;}100%{width:38px;}"])
};
var rcSwitchOff = {
  small: (0, _ykbStyledComponents.keyframes)(["0%{width:12px;}100%{width:16px;}"]),
  default: (0, _ykbStyledComponents.keyframes)(["0%{width:18px;}100%{width:25px;}"]),
  large: (0, _ykbStyledComponents.keyframes)(["0%{width:26px;}100%{width:38px;}"])
};
var WidgetIdInput = exports.WidgetIdInput = _ykbStyledComponents.default.input.withConfig({
  componentId: "ykb-ui__sc-1p7r0u-0"
})(["position:absolute;width:0px;height:0px;padding:0px;border:none;"]);
var StyledSwitch = exports.StyledSwitch = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1p7r0u-1"
})([".", "{position:relative;display:inline-block;min-width:", ";height:", ";line-height:", ";vertical-align:middle;border-radius:100px;border:1px solid transparent;background-color:", ";cursor:pointer;transition:all ", ";user-select:none;&-inner{color:#fff;font-size:", ";position:absolute;left:24px;top:0px;line-height:", ";svg{height:", ";}}&:after{position:absolute;width:", ";height:", ";top:1px;left:1px;border-radius:", ";background-color:#fff;content:' ';cursor:pointer;box-shadow:", ";transform:scale(1);transition:all ", " cubic-bezier(0.35,0,0.25,1);animation-timing-function:cubic-bezier(0.35,0,0.25,1);animation-duration:", ";animation-name:", ";}&:focus{box-shadow:", ";outline:none;}&:active{background-color:", ";box-shadow:", ";&:after{width:", ";animation-name:", ";}}&-checked{border:1px solid ", ";background-color:", ";[class*='-inner']{left:", ";}&:after{left:", ";}&:active:after{left:", ";}}&-disabled{cursor:no-drop;opacity:0.4;&:after{cursor:no-drop;background-color:", ";}&:hover:after{transform:scale(1);}}&-label{display:inline-block;line-height:20px;font-size:14px;padding-left:10px;vertical-align:middle;white-space:normal;pointer-events:none;user-select:text;}}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.Switch.minWidth[props.$size];
}, function (props) {
  return props.theme.Switch.height[props.$size];
}, function (props) {
  return props.theme.Switch.lineHeight[props.$size];
}, function (props) {
  return props.theme.Switch.baseColor;
}, function (props) {
  return props.theme.Switch.duration;
}, function (props) {
  return props.theme.Switch.fontSize;
}, function (props) {
  return props.theme.Switch.lineHeight[props.$size];
}, function (props) {
  return props.theme.Switch.height[props.$size];
}, function (props) {
  return props.theme.Switch.toogleSize[props.$size];
}, function (props) {
  return props.theme.Switch.toogleSize[props.$size];
}, function (props) {
  return props.theme.Switch.toggleBorderRadius[props.$size];
}, function (props) {
  return props.theme.Switch.toogleBoxShadow;
}, function (props) {
  return props.theme.Switch.duration;
}, function (props) {
  return props.theme.Switch.duration;
}, function (props) {
  return rcSwitchOff[props.$size];
}, function (props) {
  return props.theme.Switch.focusBoxShadow;
}, function (props) {
  return props.theme.Switch.backgroundColor.active;
}, function (props) {
  return props.theme.Switch.focusBoxShadow;
}, function (props) {
  return props.theme.Switch.toogleActiveSize[props.$size];
}, function (props) {
  return rcSwitchOn[props.$size];
}, function (props) {
  return props.theme.Switch.checkColor;
}, function (props) {
  return props.theme.Switch.checkColor;
}, function (props) {
  return props.theme.Switch.innerLeft[props.$size];
}, function (props) {
  return props.theme.Switch.toogleLeft[props.$size];
}, function (props) {
  return props.theme.Switch.toogleActiveLeft[props.$size];
}, function (props) {
  return props.theme.Switch.toogleColor.disable;
});
var StyledSwitchWrapper = exports.StyledSwitchWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1p7r0u-2"
})(["display:inline-flex;", "{margin-right:4px;}", " ", " ", ""], _Styled.default, function (props) {
  return props.$textLocation === 'right' && (0, _ykbStyledComponents.css)(["flex-direction:row-reverse;", "{margin-left:4px;}"], _Styled.default);
}, function (props) {
  return props.$size === 'large' && (0, _ykbStyledComponents.css)(["", "{line-height:30px;}"], _Styled.default);
}, function (props) {
  return props.$size === 'small' && (0, _ykbStyledComponents.css)(["", "{line-height:16px;}"], _Styled.default);
});
var StyledSwitchContainer = exports.StyledSwitchContainer = (0, _ykbStyledComponents.default)(StyledContainer).withConfig({
  componentId: "ykb-ui__sc-1p7r0u-3"
})([""]);